<span *ngIf="!showMore"><span innerHtml="{{onlyName | highlightText : searchText }}"></span><span class="showMore-txt" *ngIf="namesList && namesList.length>1" (click)="onMoreClick()"> +{{namesList.length - 1}} more</span></span>
<span *ngIf="showMore" innerHtml="{{names | highlightText : searchText }}"></span>
